export function normalizeApiUrl(url = '') {
  if (url === '.' || url === '/' || !url) {
    return '';
  }
  return new URL(url).origin;
}
